// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"2143":"app","3064":"chunk-common","4736":"vendor"}[chunkId] || chunkId) + "." + {"1532":"18565c63","2143":"0aac5d64","3064":"8e094330","4736":"38a72304","5969":"75406f48","9494":"c80f9d5e"}[chunkId] + ".css";
};